App.SmLoaderComponent = Em.Component.extend
  classNames: [ 'sm-loader' ]
  tagName: 'svg'

  size: 38

  attributeBindings: [ 'width', 'height', 'viewBox', 'stroke', 'xmlns' ]
  widthBinding:  'size'
  heightBinding: 'size'

  viewBox: (-> "0 0 #{@get('size')} #{@get('size')}").property('size')
  xmlns: 'http://www.w3.org/2000/svg'
  stroke: "#666"
